import Vue from "vue";

export default {
  namespaced: true,
  state: {
    designerAnswerView: {
      prev: 'designer-generations-questions',
      namePage: 'answers',
      data: 'answers/ANSWERS',
      active: 'answers/ANSWER_EDIT',
      plusName: 'Добавить ответ',
      hint: 'description'
    },
    designerAnswerViewNew: {
      component: 'EditImg',
      prev: 'designer-answers',
      btnText: 'Добавить ответ',
      componentData: {
        send: 'answers/ANSWER_NEW',
        editImg: true,
        imgClass: 'card__img-only card__img--small',
        uploadText: 'Добавить фотографию',
        validateImg: false,
        inputs: [
          {
            component: 'InputText',
            name: 'name',
            label: 'Название',
            className: 'col-12',
            rules: {
              required: true
            }
          },
          {
            component: 'InputTextarea',
            name: 'description',
            label: 'Вспомогательная информация',
            className: 'col-12'
          }
        ]
      }
    },
    designerAnswerViewEdit: {
      component: 'EditImg',
      prev: 'designer-answers',
      btnText: 'Сохранить изменения',
      componentData: {
        data: 'answers/ANSWER',
        send: 'answers/ANSWER_EDIT',
        editImg: true,
        imgClass: 'card__img--small',
        uploadText: 'Выбрать новую фотографию',
        inputs: [
          {
            component: 'InputText',
            name: 'name',
            label: 'Название',
            className: 'col-12',
            rules: {
              required: true
            }
          },
          {
            component: 'InputTextarea',
            name: 'description',
            label: 'Вспомогательная информация',
            className: 'col-12'
          }
        ]
      }
    },
    designerAnswerViewDelete: {
      component: 'EditImg',
      prev: 'designer-answers',
      btnText: 'Удалить ответ',
      wrapClass: 'mt50',
      componentClass: 'img-wrap--higher flex-grow-1',
      formClass: 'edit--small',
      componentData: {
        data: 'answers/ANSWER',
        send: 'answers/ANSWER_DELETE',
        editImg: false
      }
    },
    designerAnswerViewDisable: {
      component: 'EditImg',
      prev: 'designer-answers',
      btnText: 'Отключить ответ',
      wrapClass: 'mt50',
      componentClass: 'img-wrap--higher flex-grow-1',
      formClass: 'edit--small',
      componentData: {
        data: 'answers/ANSWER',
        send: 'answers/ANSWER_EDIT',
        editImg: false,
        disable: true
      }
    },
    checkAnswerView: {
      prev: 'check-generations',
      next: 'check-answers',
      namePage: 'answers',
      nextName: 'q_id',
      data: 'answers/ANSWERS',
      designer: false,
      titleClass: 'text-no-transform',
      hint: 'description'
    },
    answersData: [],
    testData: []
  },
  mutations: {
    'CHANGE_ANSWERS_DATA': (state, params) => state.answersData = params,
    'CHANGE_TEST_DATA': (state, params) => state.testData.push(params),
    'DELETE_TEST_DATA': (state, params) => {
      state.testData.splice(params);
    }
  },
  actions: {
    'ANSWERS': async (context, params) => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}answers/${params.brand}/${params.m_id}/${params.g_id}/${params.q_id}`, )
        .then(
          res => {
            for (let value of res.body) {
              if (value.photo === undefined) {
                value.photo = '/img/stub.webp';
              }
            }
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'ANSWER': async (context, params) => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}answers/${params.brand}/${params.m_id}/${params.g_id}/${params.q_id}/${params.id}`)
        .then(
          res => {
            if (res.body[0].photo === undefined) {
              res.body[0].photo = '/img/stub.webp';
            }
            res.body = res.body[0];
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'ANSWER_NEW': async (context, params) => {
      if (params.photo === '/img/stub.webp') {
        delete params.photo;
      }
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      return await Vue.http.post(`${process.env.VUE_APP_API_URL}answers`, formData)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'ANSWER_DELETE': async (context, params) => {
      params.photo = params.photo.split('/');
      params.photo = params.photo[params.photo.length - 1];
      return await Vue.http.delete(`${process.env.VUE_APP_API_URL}answers/${params.brand}/${params.m_id}/${params.g_id}/${params.q_id}/${params.id}`,)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'ANSWER_EDIT': async (context, params) => {
      params.a_id = params.id;
      delete params.id;
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      return await Vue.http.put(`${process.env.VUE_APP_API_URL}answers`, formData)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    }
  }
}